export default {"src":"/_next/static/media/logo_header.baf0a530.svg","height":43,"width":150,"blurWidth":0,"blurHeight":0};